// Синхронизация высоты вьюпорта Telegram с CSS-переменной для корректной отрисовки на Windows/Desktop
export function initTelegramViewportHeightSync(): void {
  const setHeightVar = (heightPx: number) => {
    document.documentElement.style.setProperty('--app-viewport-height', `${heightPx}px`)
  }
  const setSafeAreaBottom = (stable?: number, current?: number) => {
    if (typeof stable === 'number' && typeof current === 'number') {
      const inset = Math.max(0, current - stable)
      document.documentElement.style.setProperty('--tg-safe-area-inset-bottom', `${inset}px`)
    }
  }

  // Первичная установка по доступным данным
  const initialStable = (window as any)?.Telegram?.WebApp?.viewportStableHeight
  const initialCurrent = (window as any)?.Telegram?.WebApp?.viewportHeight
  const initialHeight = initialStable
    ?? initialCurrent
    ?? window.innerHeight

  setHeightVar(initialHeight)
  setSafeAreaBottom(initialStable, initialCurrent)

  // Если доступен WebApp API — подписываемся на изменения
  const tg = (window as any)?.Telegram?.WebApp
  if (tg) {
    try {
      // Максимально разворачиваем окно WebApp
      tg.expand()
    } catch (_) { /* no-op */ }

    tg.onEvent?.('viewportChanged', () => {
      const h = tg.viewportStableHeight ?? tg.viewportHeight ?? window.innerHeight
      setHeightVar(h)
      setSafeAreaBottom(tg.viewportStableHeight, tg.viewportHeight)
    })
  } else {
    // Фолбэк на resize вне Telegram
    window.addEventListener('resize', () => setHeightVar(window.innerHeight))
  }
}


